export default "__VITE_ASSET__CNlLI96G__"